import React from 'react';
import { pdf } from '@react-pdf/renderer';
import ReportDocument from '../components/Report/ReportDocument';

export const generatePdf = async (data, viewMode, language = 'en') => {
  const blob = await pdf(<ReportDocument data={data} viewMode={viewMode} language={language} />).toBlob();
  return blob;
};
